import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavParams } from '@ionic/angular';
import { FinanceiroLojasService } from '../../providers/financeiro-lojas.service';
import { LoaderService } from '../../providers/loader.service';

@Component({
  selector: 'app-conta-corrente-baixa',
  templateUrl: './conta-corrente-baixa.component.html',
  styleUrls: ['./conta-corrente-baixa.component.scss'],
})
export class ContaCorrenteBaixaComponent implements OnInit {
  valorTotal = 0;
  extrato = [];
  pedidos = [];
  arr = [];
  constructor(public finance: FinanceiroLojasService, public navParams: NavParams, 
    public alertCtrl: AlertController, public loader: LoaderService,
    private modalController: ModalController) { }

  ngOnInit() {    
    this.buscarExtrato();    
    for (let i = 0; i < this.navParams.data['data'].length; i++) {      
      const element = this.navParams.data['data'][i];
      this.valorTotal = this.valorTotal + element.VALOR;
      this.pedidos.push(element);
    }
  }

  padLeft(text:string, padChar:string, size:number): string {
    return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }

  async showPrompt(item) {
    this.arr = [];
    const date: Date = new Date();
    let mes: any = date.getMonth() + 1;
    let dia: any = date.getDate();
    
    let dia_atual: any = date.getFullYear()+'-'+this.padLeft(mes, '0', 2)+'-'+this.padLeft(dia, '0', 2);
    const prompt = await this.alertCtrl.create({
      header: 'Data do pagamento',
      message: "Coloque a data de pagamento dos boletos",
      inputs: [
        {
          name: 'Data',
          placeholder: '01/12/2017',
          value: dia_atual,
          type: 'date'
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirmar',
          handler: data => {
            this.arr.push(data);
            this.arr.push(this.pedidos);
            this.finalizarPagamento(this.arr, item.CONTA);
          }
        }
      ]
    });
    prompt.present();
  }
  
  confirmarPagamento(item){    
    this.showPrompt(item);
  }

  async dismiss() {
    await this.modalController.dismiss();
  }

  finalizarPagamento(arr, cc){
    this.finance.baixarAutomatica(arr, cc).then((result: any) =>{
      if(result == true){
        this.loader.presentToast("Pagamento efetuado com sucesso!");
        this.modalController.dismiss(this.pedidos);
      }
      console.log(result);
    }).catch((error: any) => {
      console.log('error: '+error);
    });
  }

  buscarExtrato(){
    this.extrato = [];
    this.finance.financeiroExtrato()
    .then((result: any) => {   
      for (let i = 0; i < result.length; i++) {
        const element = result[i];
        let img: any = "https://icon-icons.com/icons2/781/PNG/128/home_icon-icons.com_64744.png";
        if(element.BANCO_ORIGEM == 'BB'){
          img = "https://www.bb.com.br/pbb/app/docs/comum/images/structure/header/icon/apple-icon-57x57.png";
        }
        if(element.BANCO_ORIGEM == 'SANTANDER'){
          img = "https://www.santander.com.br/assets/images/favicon.png";
        }
        if(element.BANCO_ORIGEM == 'CEF'){
          img = "data:image/png;base64,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";
        }
        if(element.BANCO_ORIGEM == 'BRADESCO'){
          img = "https://banco.bradesco/assets/classic/img/favicon.ico";
        }
        if(element.BANCO_ORIGEM == 'ITAU'){
          img = "https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/img/logo-itau.png";
        }
        if(element.BANCO_ORIGEM == 'HSBC'){
          img = "http://hsbc.com.br/1/PA_esf-ca-app-content/content/themes/images/favicon.ico";
        }
        let a = {
          'CONTA' : element.CONTA,
          'BANCO_ORIGEM' : img,
          'AGEN': element.AGEN,
          'CONTA_CC': element.CONTA_CC,
          'SALDO': element.SALDO,
          'LOJA': element.LOJA
        }
        this.extrato.push(a);
      }   
      // this.extrato = result;      
    })
    .catch((error: any) => {
      console.log('error: '+error);
    });
  }

}
